import React, { ReactNode } from 'react';
import { DialogWindow } from 'ui-toolkit';

export interface ISwitchDialogWindows {
  updating: boolean;
  processingTitle: string;
  updated: boolean;
  error?: string | null;
  successTitle: string;
  successMessage: string | React.ReactNode;
  errorTitle: ReactNode;
  errorMessage?: ReactNode;
  onCancelClick: () => void;
  onRetryClick?: () => void;
  defaultDialogComponent: React.ReactElement;
}

const SwitchDialogWindows: React.FC<ISwitchDialogWindows> = ({
  updating,
  processingTitle,
  updated,
  error,
  successTitle,
  successMessage,
  onCancelClick,
  errorTitle,
  errorMessage,
  onRetryClick,
  defaultDialogComponent,
}) => {
  switch (true) {
    case updating:
      return <DialogWindow data-test-id={'processing'} type={'processing'} title={processingTitle} />;
    case updated && !error:
      return (
        <DialogWindow
          data-test-id={'success'}
          type={'success'}
          title={successTitle}
          message={successMessage}
          onClose={onCancelClick}
          autoFocus={'close'}
        />
      );
    case updated && !!error:
      return (
        <DialogWindow
          data-test-id={'error'}
          type={'error'}
          title={errorTitle}
          message={errorMessage}
          onRetry={onRetryClick}
          onClose={onCancelClick}
        />
      );
    default:
      return defaultDialogComponent;
  }
};

export default SwitchDialogWindows;
